import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  DateField
} from 'react-admin';
import CustomImageField from "../../components/custom-image-field";

const EnterpriseShow = () => (
  <Show
    title="Empresa">
    <SimpleShowLayout>
      <TextField source="id"/>
      <CustomImageField source="image_logo" label="Logo" />
      <TextField source="register_number" label="CNPJ" />
      <TextField source="name" label="Nome" />
      <BooleanField source="active" label="Ativo" />
      <DateField source="created_at" locales="pt-BR" label="Criado em" showTime />
    </SimpleShowLayout>
  </Show>
);

export default EnterpriseShow;
